<template>
	<UserRegistrationLayout class="signup-page">
		<v-dialog v-model="isWrongGoogleEmailDialogOpen" width="500">
			<div>
				<WrongGoogleEmailDialog @onConfirm="isWrongGoogleEmailDialogOpen = !isWrongGoogleEmailDialogOpen" />
			</div>
		</v-dialog>

		<div class="slot-title">Welcome to Ply</div>
		<div class="slot-title-description mb-9">Get started - it's free. No credit card needed.</div>

		<v-form @submit.prevent="onContinue" v-model="isSignupFormValid" ref="signupForm" class="user-input-box mt-9">
			<AnemicButton class="google-login-button" @click="signInWithGoogle">
				<SIcon name="google-logo" class="mr-2" />
				Sign up with Google
			</AnemicButton>
			<div class="display-flex width-100 flex-row flex-align-center px-5 my-5">
				<div class="divider width-100"></div>
				<div class="divider-text mx-2">or</div>
				<div class="divider width-100"></div>
			</div>

			<SignupTextField
				label="Email"
				iconName="email"
				:rules="emailRules"
				v-model="email"
				type="email"
				data-cy="registration-username"
				autofocus
				single-line
				placeholder="mail@email.com"
			/>
			<AnemicButton type="submit" data-cy="registration-continue" class="continue-button width-100 my-4"> Continue </AnemicButton>

			<div class="bottom-section">
				Already have an account?
				<a @click="navigateTo({ name: 'Login' })" class="primary-link-style">Log in</a>
			</div>
		</v-form>
	</UserRegistrationLayout>
</template>

<script>
import { mapActions } from 'vuex';

import UserRegistrationLayout from './userRegistration/UserRegistrationLayout';
import WrongGoogleEmailDialog from './userRegistration/WrongGoogleEmailDialog';
import SignupTextField from './userRegistration/components/SignupTextField';
import UserRegistrationMixin from './userRegistration/helpers/UserRegistrationMixin';
import UserRegistrationService from './userRegistration/helpers/UserRegistrationService';

export default {
	name: 'Signup',
	props: {
		uid: { type: String },
	},
	mixins: [UserRegistrationMixin],
	components: {
		SignupTextField,
		UserRegistrationLayout,
		WrongGoogleEmailDialog,
	},
	methods: {
		...mapActions(['loginWithGoogleToken', 'logout']),
		onContinue() {
			this.$refs.signupForm.validate();
			if (this.isSignupFormValid) {
				this.goToNextPage({ userEmail: this.email, uid: this.uid });
			} else {
				console.log('Please agree to terms of use');
			}
		},

		async signInWithGoogle() {
			const idToken = await UserRegistrationService.signInWithGoogle();
			try {
				const ret = await this.loginWithGoogleToken({ token: idToken });
				if (!ret || ret.success) {
					return;
				}
				// need to continue with signup, user was verified by google
				const { token } = ret;
				this.goToNextPage({ gtoken: token });
			} catch (err) {
				this.$toast.error(err);
			}
		},
		goToNextPage(params) {
			this.navigateTo({ name: 'UserDetailsForm', params });
		},
	},
	async mounted() {
		await this.logout({ avoidRedirect: true });
		UserRegistrationService.initializeGoogleAuth();
	},
	data() {
		return {
			email: '',
			auth2: null,
			isPasswordValid: false,
			isSignupFormValid: false,
			isWrongGoogleEmailDialogOpen: false,
			requiredRules: UserRegistrationService.getRequiredRules(),
			emailRules: UserRegistrationService.getEmailValidationRules(),
			signupReferrer: UserRegistrationService.getSignupReferrer(document.referrer),
		};
	},
};
</script>

<style scoped lang="scss">
.google-login-button {
	padding: 0px;
	width: 340px;
	height: 45px;
	background: var(--bold-border-color) !important;

	color: var(--bg-color);
	font-size: 14px !important;
}
.divider-text {
	font-size: 14px;
	color: #babdc4;
}
.divider {
	height: 1px;
	margin-top: 2px;
	background: #babdc4;
}

.bottom-section {
	font-size: 14px;
	margin-top: 60px;
	color: var(--primary-font-color);
}
.continue-button {
	height: 45px;
	padding: 0px;
	font-size: 14px !important;
	color: var(--bold-border-color);
	background: var(--bg-color) !important;
	border: 1px solid var(--bold-border-color);
}
.signup-page {
	.right-side-section {
		.user-input-box {
			// height: 400px;

			.transition-wrapper {
				overflow: hidden;
			}
			.fade-enter-active,
			.fade-leave-active {
				max-height: 450px;
				transition: all 0.8s;
			}
			.fade-enter,
			.fade-leave-to {
				max-height: 0;
				opacity: 0;
			}
		}
	}
}
</style>
